/* import __COLOCATED_TEMPLATE__ from './multi-participant.hbs'; */
/* RESPONSIBLE TEAM: team-automation-foundations */

import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import type { FinSetupBehaviorSaveParams } from 'embercom/lib/operator/fin/types';
import type Profile from 'embercom/models/ai-agent/profile';

interface Args {
  accordion: $TSFixMe;
  ruleset: $TSFixMe;
  partialSave: (params: FinSetupBehaviorSaveParams) => void;
}

interface Signature {
  Args: Args;
}

export default class MultiParticipant extends Component<Signature> {
  @tracked silentWhenCcRecipient: boolean = this.behavior.finSilentWhenCcRecipient ?? false;
  @tracked replyToSenderOnly: boolean = this.behavior.finReplyToSenderOnly ?? false;

  private originalSilentWhenCcRecipient: boolean = this.silentWhenCcRecipient;
  private originalReplyToSenderOnly: boolean = this.replyToSenderOnly;

  get ruleset() {
    return this.args.ruleset;
  }

  get behavior(): Profile {
    return this.ruleset.rulesetLinks.firstObject.object;
  }

  get participationOptions() {
    return [
      {
        value: false as const,
        translationKey:
          'operator.fin.setup.setup-and-go-live.multi-participant.participation.option-reply-all',
      },
      {
        value: true as const,
        translationKey:
          'operator.fin.setup.setup-and-go-live.multi-participant.participation.option-not-respond-when-cc',
      },
    ];
  }

  get replyScopeOptions() {
    return [
      {
        value: false as const,
        translationKey:
          'operator.fin.setup.setup-and-go-live.multi-participant.reply-scope.option-reply-all',
      },
      {
        value: true as const,
        translationKey:
          'operator.fin.setup.setup-and-go-live.multi-participant.reply-scope.option-reply-to-sender-only',
      },
    ];
  }

  @action
  setSilentWhenCcRecipient(value: boolean) {
    this.silentWhenCcRecipient = value;
  }

  @action
  setReplyToSenderOnly(value: boolean) {
    this.replyToSenderOnly = value;
  }

  @action
  cancel(close: () => void) {
    this.silentWhenCcRecipient = this.originalSilentWhenCcRecipient;
    this.replyToSenderOnly = this.originalReplyToSenderOnly;
    close();
  }

  @action
  async updateMultiParticipantConfig() {
    this.args.partialSave({
      fin_silent_when_cc_recipient: this.silentWhenCcRecipient,
      fin_reply_to_sender_only: this.replyToSenderOnly,
    });
    this.originalSilentWhenCcRecipient = this.silentWhenCcRecipient;
    this.originalReplyToSenderOnly = this.replyToSenderOnly;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Operator::Fin::Setup::Sections::MultiParticipant': typeof MultiParticipant;
    'operator/fin/setup/sections/multi-participant': typeof MultiParticipant;
  }
}
